module.exports = __webpack_public_path__ + "assets/montserrat-medium.5ca400bca4a2a2ff7b1b831b4a5359fe.woff";